/*
 * Mobile-only "mini circle" count badge on the header cart icon
 * (sections/header.liquid's mobile media query styles it; the badge's own
 * markup — icon + .cart-count-bubble — is shared between that file's
 * initial page-load render and sections/cart-icon-bubble.liquid, which is
 * what Dawn's cart-drawer JS actually fetches and swaps into
 * #cart-icon-bubble after every in-drawer cart change).
 *
 * This script keeps the badge's number in sync after an Add to Cart
 * specifically — that action doesn't trigger Dawn's own section-swap the
 * way in-drawer quantity changes do, so nothing else on the page updated
 * it. Subscribes to the same PUB_SUB_EVENTS.cartUpdate event Dawn's own
 * product-form.js / cart.js already publish after any cart change, then
 * re-fetches /cart.js for the authoritative item_count.
 *
 * 2026-08-29 follow-up (real bug fix): this used to grab the count/label
 * <span> elements ONCE up front and keep writing to those same references
 * on every update. The very first time an in-drawer quantity change made
 * Dawn's cart-drawer JS swap #cart-icon-bubble's contents (a real DOM
 * replacement, not an edit), those cached spans became detached — still
 * updated by this script, just invisibly, off-page. Meanwhile the new
 * spans actually on screen kept whatever value the last real
 * cart-icon-bubble section render left them at, which could be a stale
 * count from partway through a rapid sequence of adds/removes,
 * surfacing as "the cart... automatically updates to the original cart
 * we had" after clearing it back to 0. Fixed by re-querying the live
 * elements inside applyCount() on every call instead of caching them.
 *
 * 2026-08-29 follow-up #2: applyCount() also toggles a `has-cart-items`
 * class on bubbleWrap itself (the #cart-icon-bubble <a>) so the mobile
 * badge (sections/header.liquid's `.header__icon--cart.has-cart-items
 * .cart-count-bubble` rule) hides completely on an empty cart instead of
 * showing an empty/zero circle — that <a> is the one element Dawn's
 * cart-drawer swap never replaces, so a class toggled here survives every
 * subsequent swap same as the digit itself does.
 */
(function () {
  var bubbleWrap = document.getElementById('cart-icon-bubble');
  if (!bubbleWrap) return;

  function applyCount(count) {
    bubbleWrap.classList.toggle('has-cart-items', count > 0);
    var bubble = bubbleWrap.querySelector('.cart-count-bubble');
    if (!bubble) return;
    var visibleCount = bubble.querySelector('span[aria-hidden="true"]');
    var hiddenLabel = bubble.querySelector('.visually-hidden');
    if (visibleCount) visibleCount.textContent = count;
    if (hiddenLabel) hiddenLabel.textContent = count + (count === 1 ? ' item' : ' items');
  }

  // requestToken tags each fetch with the count of cartUpdate events seen
  // so far; a response is only applied if it's still the most recently
  // *started* request by the time it resolves, so a late-arriving response
  // from an earlier, now-superseded change can't overwrite a newer one.
  var requestToken = 0;

  // PUB_SUB_EVENTS/subscribe are declared with `const`/`function` at the top
  // level of other classic (non-module) script tags on this page — that
  // makes them valid bare identifiers here (shared global scope), but NOT
  // properties of `window` (unlike `var`), so `window.PUB_SUB_EVENTS` reads
  // as undefined even though `PUB_SUB_EVENTS` itself resolves fine.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      requestToken += 1;
      var thisToken = requestToken;
      fetch('/cart.js')
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          if (thisToken !== requestToken) return;
          applyCount(cart.item_count);
        });
    });
  }
})();
